import React from "react";
import styled from "styled-components";
import { theme } from "styles/theme";

const ErrorText = styled.small`
  color: ${theme.colors.error};
  display: block;
  margin-top: 0.25rem;
`;

interface FormErrorProps {
  id: string;
  children?: React.ReactNode;
}

/** Renders field error text with an id for aria-describedby. */
export function FormError({ id, children }: FormErrorProps) {
  if (!children) return null;

  return (
    <ErrorText id={id} role="alert">
      {children}
    </ErrorText>
  );
}

/**
 * Aria props for an input bound to a FormError with id `${fieldId}-error`.
 * Spread onto the control alongside register()/Controller field props.
 */
export function getFieldAriaProps(fieldId: string, errorMessage?: string) {
  return {
    id: fieldId,
    "aria-invalid": Boolean(errorMessage) || undefined,
    "aria-describedby": errorMessage ? `${fieldId}-error` : undefined,
  } as const;
}

export function fieldErrorId(fieldId: string) {
  return `${fieldId}-error`;
}
